<script lang="ts">
import { getContext } from 'svelte'

import { testIds } from '@/constants'
import { contentListItemKey, type WritableMessageContext } from '@/modules/messages'

import MessageComponent from './Message.svelte'
import MessageAttachment from './MessageAttachment.svelte'
import MessageDateTooltip from './MessageDateTooltip.svelte'
import MessageInfo from './MessageInfo.svelte'

type Props = {
	isContact?: boolean
}

let { isContact = false }: Props = $props()

let context = $derived(getContext<WritableMessageContext>(contentListItemKey))
let { id, createdAt } = $derived($context.message)

let { attachmentsContext } = $derived($context)
</script>

{#each $context.attachmentsContext as attachmentContext, index (index)}
	{@const { hasBottom, hasTop } = attachmentContext.extraSpaces}
	<div class={[hasBottom && 'mb-4', hasTop && 'mt-4']} data-testid={testIds.messageAttachment}>
		<MessageComponent {isContact}>
			<MessageDateTooltip {createdAt}>
				<MessageAttachment context={attachmentContext} />
				<MessageInfo {id} {createdAt} isLastAttachment={attachmentsContext.length - 1 === index} />
			</MessageDateTooltip>
		</MessageComponent>
	</div>
{/each}
